/* eslint-disable @wyz/i18n/no-plain-text */
import { Button, Card, Col, Flex, Icon, Row } from '@wyz/ui';
import { Section } from '~/common/components';
import { Trans } from '~/common/context';
import { SUPPORT_EMAIL } from '~/common/helpers';

/**
 * Error page shown when the application context fails to load.
 *
 * It renders above the ApplicationContext provider, so it must not use any hook
 * that reads that context (useApplicationContext, useAccessControl, ErrorLayout
 * through PlatformLogo, ...) — those throw when the context is missing.
 */
const ApplicationContextError = () => {
  return (
    <Section className='py-0'>
      <Row className='flex-center py-6'>
        <Col sm={11} md={9} lg={7} xl={6} className='col-xxl-5'>
          <Card className='text-center'>
            <Card.Body className='p-5'>
              <div className='display-1 text-300 fs-error'>500</div>
              <p className='lead mt-4 text-800 font-sans-serif fw-semi-bold'>
                <Trans i18nKey='app.errors.500.title' />
              </p>
              <hr />
              <p>
                <Trans i18nKey='app.errors.500.message' />
                <a href={`mailto:${SUPPORT_EMAIL}`} className='ms-1'>
                  contact us
                </a>
                .
              </p>
              <Flex alignItems='center' justifyContent='center'>
                <Button
                  id='retry-application-context'
                  variant='primary'
                  type='button'
                  size='sm'
                  onClick={() => window.location.reload()}
                >
                  <Icon icon={'home'} size='xs' className='me-2' />
                  <Trans i18nKey='app.common.sidebar.dashboard' />
                </Button>
              </Flex>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default ApplicationContextError;
